export default __webpack_public_path__ + "static/media/cp_geo_eh.799b45ba.svg";